<template>
  <section class="section_panel">
    <h5 class="section_title">
      <i class="fal fa-chart-bar"></i>
      {{ $t("TITLES.showBundle") }}
    </h5>

    <div class="cards_grid cards_grid--stats">
      <div
        v-for="stat in stats"
        :key="stat.key"
        class="bundle_card bundle_card--stat"
      >
        <div class="bundle_card__icon">
          <i :class="stat.icon"></i>
        </div>
        <div class="bundle_card__body">
          <span class="bundle_card__label">{{ stat.label }}</span>
          <span
            class="bundle_card__value"
            :class="{ 'bundle_card__value--emphasis': stat.emphasis }"
          >{{ stat.value }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  formatDistance,
  formatDuration,
  formatPackageDims,
} from "../utils/bundleHelpers";

export default {
  name: "BundleSummaryStats",

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    stats() {
      const d = this.data;
      const t = this.$t.bind(this);

      return [
        {
          key: "pickup",
          icon: "fal fa-map-marker-alt",
          label: t("PLACEHOLDERS.pickup_point"),
          value: d.provider?.address?.address || "-",
        },
        {
          key: "delivery_points",
          icon: "fal fa-map-marked-alt",
          label: t("PLACEHOLDERS.delivery_points_count"),
          value: d.delivery_point_count || 0,
          emphasis: true,
        },
        {
          key: "packages",
          icon: "fal fa-box",
          label: t("PLACEHOLDERS.packages_count"),
          value: d.packages_count || 0,
          emphasis: true,
        },
        {
          key: "max_dims",
          icon: "fal fa-expand-arrows-alt",
          label: t("PLACEHOLDERS.max_package_dims"),
          value: d.max_package_dims
            ? formatPackageDims(d.max_package_dims, t)
            : "-",
        },
        {
          key: "min_dims",
          icon: "fal fa-compress-arrows-alt",
          label: t("PLACEHOLDERS.min_package_dims"),
          value: d.min_package_dims
            ? formatPackageDims(d.min_package_dims, t)
            : "-",
        },
        {
          key: "weight",
          icon: "fal fa-weight",
          label: t("PLACEHOLDERS.total_weight"),
          value: `${d.total_weight || d.weight || "-"} ${t("PLACEHOLDERS.kg")}`,
          emphasis: true,
        },
        {
          key: "price",
          icon: "fal fa-coins",
          label: t("PLACEHOLDERS.delivery_price_details"),
          value: `${d.delivery_prize || 0} ${t("PLACEHOLDERS.sar_currency")}`,
          emphasis: true,
        },
        {
          key: "distance",
          icon: "fal fa-route",
          label: t("PLACEHOLDERS.expected_distance"),
          value: formatDistance(d.distance_km, t),
        },
        {
          key: "duration",
          icon: "fal fa-clock",
          label: t("PLACEHOLDERS.estimated_duration"),
          value: formatDuration(d.duration_mins, t),
        },
      ];
    },
  },
};
</script>
